import { render, staticRenderFns } from "./SubscriptionDetail.vue?vue&type=template&id=c54ac3d8&scoped=true"
import script from "./SubscriptionDetail.vue?vue&type=script&lang=js"
export * from "./SubscriptionDetail.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionDetail.vue?vue&type=style&index=0&id=c54ac3d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54ac3d8",
  null
  
)

export default component.exports